// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .cs-grid {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0;
  margin-left: 0;
  margin-top: 0;
}

::ng-deep .article-main-content-wrapper {
  border-radius: 2rem;
  box-shadow: var(--shadow-3);
}
::ng-deep p-blockui .p-blockui {
  z-index: 10000;
  border-radius: 2rem;
}
::ng-deep p-panel.loading-p-panel {
  border: none;
  margin: 0;
  padding: 0;
}
::ng-deep p-panel.loading-p-panel .p-panel-header {
  display: none;
}
::ng-deep p-panel.loading-p-panel .p-panel-content {
  background: transparent !important;
  border: none !important;
  padding: 0;
  margin: 0;
}
::ng-deep .cs-card:last-child {
  margin-bottom: 0;
}
::ng-deep .cs-card {
  background-color: var(--surface-card);
  padding: 1rem;
  margin-bottom: 2rem;
  border: 1px solid var(--surface-border);
  border-radius: 10px; /*var(--border-radius);*/
}
::ng-deep .cs-align-items-center {
  align-items: center !important;
}
::ng-deep .cs-justify-content-between {
  justify-content: space-between !important;
}
::ng-deep .cs-flex {
  display: flex !important;
}
::ng-deep .cs-text-3xl {
  font-size: 1.75rem !important;
}
::ng-deep .cs-font-bold {
  font-weight: 700 !important;
}
::ng-deep .cs-text-color {
  color: var(--text-color) !important;
}
::ng-deep .cs-mb-0 {
  margin-bottom: 0 !important;
}
::ng-deep .cs-mt-2 {
  margin-top: 0.5rem !important;
}
::ng-deep .cs-text-2xl {
  font-size: 1.5rem !important;
}
::ng-deep .cs-text-color-secondary {
  color: var(--text-color-secondary) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/secure/dashboard/dashboard.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AACD;;AAGC;EACC,mBAAA;EACA,2BAAA;AAAF;AAIE;EAAY,cAAA;EAAgB,mBAAA;AAA9B;AAIE;EACC,YAAA;EACA,SAAA;EACA,UAAA;AAFH;AAIG;EACC,aAAA;AAFJ;AAKG;EACC,kCAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AAHJ;AAQC;EACC,gBAAA;AANF;AASC;EACC,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA,EAAA,wBAAA;AAPF;AAUC;EACC,8BAAA;AARF;AAWC;EACC,yCAAA;AATF;AAYC;EACC,wBAAA;AAVF;AAaC;EACC,6BAAA;AAXF;AAcC;EACC,2BAAA;AAZF;AAeC;EACC,mCAAA;AAbF;AAgBC;EACC,2BAAA;AAdF;AAiBC;EACC,6BAAA;AAfF;AAkBC;EACC,4BAAA;AAhBF;AAmBC;EACC,6CAAA;AAjBF","sourcesContent":["::ng-deep .cs-grid {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-right: 0;\n\tmargin-left: 0;\n\tmargin-top: 0;\n}\n\n::ng-deep {\n\t.article-main-content-wrapper {\n\t\tborder-radius: 2rem;\n\t\tbox-shadow: var(--shadow-3);\n\t}\n\n\tp-blockui {\n\t\t.p-blockui {z-index: 10000; border-radius: 2rem;}\n\t}\n\n\tp-panel {\n\t\t&.loading-p-panel {\n\t\t\tborder: none;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\n\t\t\t.p-panel-header {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\n\t\t\t.p-panel-content {\n\t\t\t\tbackground: transparent !important;\n\t\t\t\tborder: none !important;\n\t\t\t\tpadding: 0;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t.cs-card:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.cs-card {\n\t\tbackground-color: var(--surface-card);\n\t\tpadding: 1rem;\n\t\tmargin-bottom: 2rem;\n\t\tborder: 1px solid var(--surface-border);\n\t\tborder-radius: 10px; /*var(--border-radius);*/\n\t}\n\n\t.cs-align-items-center {\n\t\talign-items: center !important;\n\t}\n\n\t.cs-justify-content-between {\n\t\tjustify-content: space-between !important;\n\t}\n\n\t.cs-flex {\n\t\tdisplay: flex !important;\n\t}\n\n\t.cs-text-3xl {\n\t\tfont-size: 1.75rem !important;\n\t}\n\n\t.cs-font-bold {\n\t\tfont-weight: 700 !important;\n\t}\n\n\t.cs-text-color {\n\t\tcolor: var(--text-color) !important;\n\t}\n\n\t.cs-mb-0 {\n\t\tmargin-bottom: 0 !important;\n\t}\n\n\t.cs-mt-2 {\n\t\tmargin-top: 0.5rem !important;\n\t}\n\n\t.cs-text-2xl {\n\t\tfont-size: 1.5rem !important;\n\t}\n\n\t.cs-text-color-secondary {\n\t\tcolor: var(--text-color-secondary) !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
